import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';

function CopilotResponseView({ message='' }) {

  return (
    <div className="prose max-w-none copilot-response-view">
      <ReactMarkdown
        children={message}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, rehypeSanitize]}
      />
    </div>
  );
}

export default CopilotResponseView;